<script setup lang="ts">
defineProps<{
  error?: string | boolean;
}>();

const model = defineModel<string>();

defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <textarea
    v-bind="$attrs"
    v-model="model"
    :class="[
      'w-full resize-none appearance-none rounded-[6px] border-0 px-4 py-3 text-sm font-medium text-on-primary-heading ring transition-colors outline-none ring-inset placeholder:text-on-primary-heading/40 focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-75 md:text-base',
      error ? 'ring-red-500' : 'ring-on-primary-heading',
    ]"
  />
</template>
